/**
 * Keep in mind that this has to be in sync with
 * olive/library/Olive/View/Catalog/NoResults/SuggestionSorter.php
 */

import { sortBy } from '../../../lib/utilities';
import { Filters } from '../../_flux/constants/filter/filters';
import {
    TYPE_IMPROVABLE,
} from './suggestion';

const SUGGESTION_ORDER = [
    Filters.PRICE_MIN,
    Filters.PRICE_MAX,
    Filters.LOAD_INDEX,
    Filters.SPEED_INDEX,
    Filters.MANUFACTURER,
    Filters.MODEL,
    Filters.BUY_4_PAY_3,
    Filters.INSTANT_CASH,
    Filters.CLEARANCE,
    Filters.RUN_FLAT,
    Filters.VEHICLE_TYPE,
];

function sortSuggestions(suggestions) {
    const sortedSuggestions = suggestions
        .map(suggestion => ({ ...suggestion, sequence: sortSuggestionsByRanking(suggestion) }))
        .sort((a, b) => sortBy('sequence')(a, b));

    const sortedSuggestionsWithMin = sortPriceOption(sortedSuggestions, Filters.PRICE_MIN);
    return sortPriceOption(sortedSuggestionsWithMin, Filters.PRICE_MAX);
}

function sortSuggestionsByRanking(suggestion) {
    return SUGGESTION_ORDER.indexOf(suggestion.facetName);
}

/**
 * Checks if the 'lowest' (the one resulting in the most results) price (min or max) option is already selected
 * If yes, move it to the end
 *
 * Eg: Min Price Options are $50, $100 and $150 and min price is already $50, it will be moved to the end
 */
function sortPriceOption(suggestions, facetName) {
    const priceSuggestionIndex = suggestions.findIndex((suggestion) => suggestion.facetName === facetName);
    const priceSuggestion = suggestions[priceSuggestionIndex];

    if (!priceSuggestion || priceSuggestion.type === TYPE_IMPROVABLE) {
        return suggestions;
    }

    return suggestions
        .slice(0, priceSuggestionIndex)
        .concat(suggestions.slice(priceSuggestionIndex + 1))
        .concat([priceSuggestion]);
}

export { sortSuggestions };
